import React from 'react';
import styleBinder from 'classnames/bind';
import style from './content.module.css';

export const Content = ({ inline = false, fixed = false, ...props }) => {
    const cx = styleBinder.bind(style);
    const className = cx('content', { inline: inline, fixed: fixed });

    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    return <div {...props} className={className} />;
};
